import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FilterItem } from 'src/storage/contact-search/search.state';
import * as E from "linq";


@Component({
  selector: 'advanced-filter-checkbox-list',
  templateUrl: './advanced-filter-checkbox-list.component.html',
  styleUrls: ['./advanced-filter-checkbox-list.component.scss']
})
export class AdvancedFilterCheckboxListComponent implements OnChanges {

  @Input() items: FilterItem[];
  @Output() changed = new EventEmitter<{ items: FilterItem[] }>();


  innerItems: FilterItem[];

  constructor() { }


  ngOnChanges(changes: SimpleChanges): void {

    if ("items" in changes) {
      const currentValue: FilterItem[] = changes.items.currentValue;
      this.innerItems = E.from(currentValue).select(i => ({ ...i })).toArray();
    }
  }
}
